const state = {
  user: JSON.parse(localStorage.getItem("user")) || null,
  accessToken: localStorage.getItem("accessToken") || null,
  refreshToken: localStorage.getItem("refreshToken") || null,
}

const getters = {
  user: (state) => state.user,
  accessToken: (state) => state.accessToken,
  refreshToken: (state) => state.refreshToken,
  isAuthenticated: (state) => !!state.accessToken,
}

const mutations = {
  SET_AUTH(state, { user, access, refresh }) {
    state.user = user
    state.accessToken = access
    state.refreshToken = refresh

    localStorage.setItem("user", JSON.stringify(user || {}))
    localStorage.setItem("accessToken", access)
    localStorage.setItem("refreshToken", refresh)
  },

  UPDATE_ACCESS_TOKEN(state, access) {
    state.accessToken = access
    localStorage.setItem("accessToken", access)
  },

  UPDATE_REFRESH_TOKEN(state, refresh) {
    state.refreshToken = refresh
    localStorage.setItem("refreshToken", refresh)
  },

  LOGOUT(state) {
    state.user = null
    state.accessToken = null
    state.refreshToken = null

    localStorage.removeItem("user")
    localStorage.removeItem("accessToken")
    localStorage.removeItem("refreshToken")
  },
}

const actions = {
  async login({ commit }, payload) {
    const response = await fetch("https://avtotesting.uz/api/account/login/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })

    let data
    try {
      data = await response.json()
    } catch (err) {
      throw new Error("Server javobi JSON emas")
    }

    if (!response.ok) {
      throw data
    }

    const access  = data.access  || (data.tokens && data.tokens.access)
    const refresh = data.refresh || (data.tokens && data.tokens.refresh)
    const user    = data.user || null

    if (!access || !refresh) {
      console.error("Backend javobida token topilmadi → ", data)
      throw new Error("access yoki refresh token yo‘q")
    }

    commit("SET_AUTH", { user, access, refresh })
    return data
  },

  async refreshToken({ state, commit, dispatch }) {
    if (!state.refreshToken) {
      dispatch("logout")
      throw new Error("Refresh token yo‘q")
    }

    const response = await fetch("https://avtotesting.uz/api/account/token/refresh/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh: state.refreshToken }),
    })

    const data = await response.json()

    if (!response.ok) {
      dispatch("logout")
      throw data
    }

    commit("UPDATE_ACCESS_TOKEN", data.access)
    if (data.refresh) commit("UPDATE_REFRESH_TOKEN", data.refresh)

    return data
  },

  logout({ commit }) {
    commit("LOGOUT")
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}